import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  experiencesCreateExperience,
  SimpleExperienceResource,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateExperience = (
  options: UseMutationOptions<
    void,
    unknown,
    SimpleExperienceResource,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      await extractData(
        experiencesCreateExperience({
          body: data,
        })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['experiences'],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
